// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"386":"b10eb11b","844":"a26bbfe9"}[chunkId] + ".css";
};